import { render, staticRenderFns } from "./BasicQuery.vue?vue&type=template&id=f78aa24c&scoped=true&"
import script from "./BasicQuery.vue?vue&type=script&lang=js&"
export * from "./BasicQuery.vue?vue&type=script&lang=js&"
import style0 from "./BasicQuery.vue?vue&type=style&index=0&id=f78aa24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78aa24c",
  null
  
)

export default component.exports